/////////////////////////////
/////////////////////////////
// PLUGINS
/////////////////////////////
/////////////////////////////



/*! * imagesLoaded PACKAGED v3.1.1 * JavaScript is all like "You images are done yet or what?" * MIT License */
(function(){function e(){}function t(e,t){for(var n=e.length;n--;)if(e[n].listener===t)return n;return-1}function n(e){return function(){return this[e].apply(this,arguments)}}var i=e.prototype,r=this,o=r.EventEmitter;i.getListeners=function(e){var t,n,i=this._getEvents();if("object"==typeof e){t={};for(n in i)i.hasOwnProperty(n)&&e.test(n)&&(t[n]=i[n])}else t=i[e]||(i[e]=[]);return t},i.flattenListeners=function(e){var t,n=[];for(t=0;e.length>t;t+=1)n.push(e[t].listener);return n},i.getListenersAsObject=function(e){var t,n=this.getListeners(e);return n instanceof Array&&(t={},t[e]=n),t||n},i.addListener=function(e,n){var i,r=this.getListenersAsObject(e),o="object"==typeof n;for(i in r)r.hasOwnProperty(i)&&-1===t(r[i],n)&&r[i].push(o?n:{listener:n,once:!1});return this},i.on=n("addListener"),i.addOnceListener=function(e,t){return this.addListener(e,{listener:t,once:!0})},i.once=n("addOnceListener"),i.defineEvent=function(e){return this.getListeners(e),this},i.defineEvents=function(e){for(var t=0;e.length>t;t+=1)this.defineEvent(e[t]);return this},i.removeListener=function(e,n){var i,r,o=this.getListenersAsObject(e);for(r in o)o.hasOwnProperty(r)&&(i=t(o[r],n),-1!==i&&o[r].splice(i,1));return this},i.off=n("removeListener"),i.addListeners=function(e,t){return this.manipulateListeners(!1,e,t)},i.removeListeners=function(e,t){return this.manipulateListeners(!0,e,t)},i.manipulateListeners=function(e,t,n){var i,r,o=e?this.removeListener:this.addListener,s=e?this.removeListeners:this.addListeners;if("object"!=typeof t||t instanceof RegExp)for(i=n.length;i--;)o.call(this,t,n[i]);else for(i in t)t.hasOwnProperty(i)&&(r=t[i])&&("function"==typeof r?o.call(this,i,r):s.call(this,i,r));return this},i.removeEvent=function(e){var t,n=typeof e,i=this._getEvents();if("string"===n)delete i[e];else if("object"===n)for(t in i)i.hasOwnProperty(t)&&e.test(t)&&delete i[t];else delete this._events;return this},i.removeAllListeners=n("removeEvent"),i.emitEvent=function(e,t){var n,i,r,o,s=this.getListenersAsObject(e);for(r in s)if(s.hasOwnProperty(r))for(i=s[r].length;i--;)n=s[r][i],n.once===!0&&this.removeListener(e,n.listener),o=n.listener.apply(this,t||[]),o===this._getOnceReturnValue()&&this.removeListener(e,n.listener);return this},i.trigger=n("emitEvent"),i.emit=function(e){var t=Array.prototype.slice.call(arguments,1);return this.emitEvent(e,t)},i.setOnceReturnValue=function(e){return this._onceReturnValue=e,this},i._getOnceReturnValue=function(){return this.hasOwnProperty("_onceReturnValue")?this._onceReturnValue:!0},i._getEvents=function(){return this._events||(this._events={})},e.noConflict=function(){return r.EventEmitter=o,e},"function"==typeof define&&define.amd?define("eventEmitter/EventEmitter",[],function(){return e}):"object"==typeof module&&module.exports?module.exports=e:this.EventEmitter=e}).call(this),function(e){function t(t){var n=e.event;return n.target=n.target||n.srcElement||t,n}var n=document.documentElement,i=function(){};n.addEventListener?i=function(e,t,n){e.addEventListener(t,n,!1)}:n.attachEvent&&(i=function(e,n,i){e[n+i]=i.handleEvent?function(){var n=t(e);i.handleEvent.call(i,n)}:function(){var n=t(e);i.call(e,n)},e.attachEvent("on"+n,e[n+i])});var r=function(){};n.removeEventListener?r=function(e,t,n){e.removeEventListener(t,n,!1)}:n.detachEvent&&(r=function(e,t,n){e.detachEvent("on"+t,e[t+n]);try{delete e[t+n]}catch(i){e[t+n]=void 0}});var o={bind:i,unbind:r};"function"==typeof define&&define.amd?define("eventie/eventie",o):e.eventie=o}(this),function(e){function t(e,t){for(var n in t)e[n]=t[n];return e}function n(e){return"[object Array]"===f.call(e)}function i(e){var t=[];if(n(e))t=e;else if("number"==typeof e.length)for(var i=0,r=e.length;r>i;i++)t.push(e[i]);else t.push(e);return t}function r(e,n){function r(e,n,s){if(!(this instanceof r))return new r(e,n);"string"==typeof e&&(e=document.querySelectorAll(e)),this.elements=i(e),this.options=t({},this.options),"function"==typeof n?s=n:t(this.options,n),s&&this.on("always",s),this.getImages(),o&&(this.jqDeferred=new o.Deferred);var c=this;setTimeout(function(){c.check()})}function f(e){this.img=e}function a(e){this.src=e,h[e]=this}r.prototype=new e,r.prototype.options={},r.prototype.getImages=function(){this.images=[];for(var e=0,t=this.elements.length;t>e;e++){var n=this.elements[e];"IMG"===n.nodeName&&this.addImage(n);for(var i=n.querySelectorAll("img"),r=0,o=i.length;o>r;r++){var s=i[r];this.addImage(s)}}},r.prototype.addImage=function(e){var t=new f(e);this.images.push(t)},r.prototype.check=function(){function e(e,r){return t.options.debug&&c&&s.log("confirm",e,r),t.progress(e),n++,n===i&&t.complete(),!0}var t=this,n=0,i=this.images.length;if(this.hasAnyBroken=!1,!i)return this.complete(),void 0;for(var r=0;i>r;r++){var o=this.images[r];o.on("confirm",e),o.check()}},r.prototype.progress=function(e){this.hasAnyBroken=this.hasAnyBroken||!e.isLoaded;var t=this;setTimeout(function(){t.emit("progress",t,e),t.jqDeferred&&t.jqDeferred.notify(t,e)})},r.prototype.complete=function(){var e=this.hasAnyBroken?"fail":"done";this.isComplete=!0;var t=this;setTimeout(function(){if(t.emit(e,t),t.emit("always",t),t.jqDeferred){var n=t.hasAnyBroken?"reject":"resolve";t.jqDeferred[n](t)}})},o&&(o.fn.imagesLoaded=function(e,t){var n=new r(this,e,t);return n.jqDeferred.promise(o(this))}),f.prototype=new e,f.prototype.check=function(){var e=h[this.img.src]||new a(this.img.src);if(e.isConfirmed)return this.confirm(e.isLoaded,"cached was confirmed"),void 0;if(this.img.complete&&void 0!==this.img.naturalWidth)return this.confirm(0!==this.img.naturalWidth,"naturalWidth"),void 0;var t=this;e.on("confirm",function(e,n){return t.confirm(e.isLoaded,n),!0}),e.check()},f.prototype.confirm=function(e,t){this.isLoaded=e,this.emit("confirm",this,t)};var h={};return a.prototype=new e,a.prototype.check=function(){if(!this.isChecked){var e=new Image;n.bind(e,"load",this),n.bind(e,"error",this),e.src=this.src,this.isChecked=!0}},a.prototype.handleEvent=function(e){var t="on"+e.type;this[t]&&this[t](e)},a.prototype.onload=function(e){this.confirm(!0,"onload"),this.unbindProxyEvents(e)},a.prototype.onerror=function(e){this.confirm(!1,"onerror"),this.unbindProxyEvents(e)},a.prototype.confirm=function(e,t){this.isConfirmed=!0,this.isLoaded=e,this.emit("confirm",this,t)},a.prototype.unbindProxyEvents=function(e){n.unbind(e.target,"load",this),n.unbind(e.target,"error",this)},r}var o=e.jQuery,s=e.console,c=s!==void 0,f=Object.prototype.toString;"function"==typeof define&&define.amd?define(["eventEmitter/EventEmitter","eventie/eventie"],r):e.imagesLoaded=r(e.EventEmitter,e.eventie)}(window);

/*! fancyBox v2.1.5 fancyapps.com | fancyapps.com/fancybox/#license */
(function(r,G,f,v){var J=f("html"),n=f(r),p=f(G),b=f.fancybox=function(){b.open.apply(this,arguments)},I=navigator.userAgent.match(/msie/i),B=null,s=G.createTouch!==v,t=function(a){return a&&a.hasOwnProperty&&a instanceof f},q=function(a){return a&&"string"===f.type(a)},E=function(a){return q(a)&&0<a.indexOf("%")},l=function(a,d){var e=parseInt(a,10)||0;d&&E(a)&&(e*=b.getViewport()[d]/100);return Math.ceil(e)},w=function(a,b){return l(a,b)+"px"};f.extend(b,{version:"2.1.5",defaults:{padding:15,margin:20, width:800,height:600,minWidth:100,minHeight:100,maxWidth:9999,maxHeight:9999,pixelRatio:1,autoSize:!0,autoHeight:!1,autoWidth:!1,autoResize:!0,autoCenter:!s,fitToView:!0,aspectRatio:!1,topRatio:0.5,leftRatio:0.5,scrolling:"auto",wrapCSS:"",arrows:!0,closeBtn:!0,closeClick:!1,nextClick:!1,mouseWheel:!0,autoPlay:!1,playSpeed:3E3,preload:3,modal:!1,loop:!0,ajax:{dataType:"html",headers:{"X-fancyBox":!0}},iframe:{scrolling:"auto",preload:!0},swf:{wmode:"transparent",allowfullscreen:"true",allowscriptaccess:"always"}, keys:{next:{13:"left",34:"up",39:"left",40:"up"},prev:{8:"right",33:"down",37:"right",38:"down"},close:[27],play:[32],toggle:[70]},direction:{next:"left",prev:"right"},scrollOutside:!0,index:0,type:null,href:null,content:null,title:null,tpl:{wrap:'<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',image:'<img class="fancybox-image" src="{href}" alt="" />',iframe:'<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen'+ (I?' allowtransparency="true"':"")+"></iframe>",error:'<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',closeBtn:'<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',next:'<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',prev:'<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>'},openEffect:"fade",openSpeed:250,openEasing:"swing",openOpacity:!0, openMethod:"zoomIn",closeEffect:"fade",closeSpeed:250,closeEasing:"swing",closeOpacity:!0,closeMethod:"zoomOut",nextEffect:"elastic",nextSpeed:250,nextEasing:"swing",nextMethod:"changeIn",prevEffect:"elastic",prevSpeed:250,prevEasing:"swing",prevMethod:"changeOut",helpers:{overlay:!0,title:!0},onCancel:f.noop,beforeLoad:f.noop,afterLoad:f.noop,beforeShow:f.noop,afterShow:f.noop,beforeChange:f.noop,beforeClose:f.noop,afterClose:f.noop},group:{},opts:{},previous:null,coming:null,current:null,isActive:!1, isOpen:!1,isOpened:!1,wrap:null,skin:null,outer:null,inner:null,player:{timer:null,isActive:!1},ajaxLoad:null,imgPreload:null,transitions:{},helpers:{},open:function(a,d){if(a&&(f.isPlainObject(d)||(d={}),!1!==b.close(!0)))return f.isArray(a)||(a=t(a)?f(a).get():[a]),f.each(a,function(e,c){var k={},g,h,j,m,l;"object"===f.type(c)&&(c.nodeType&&(c=f(c)),t(c)?(k={href:c.data("fancybox-href")||c.attr("href"),title:c.data("fancybox-title")||c.attr("title"),isDom:!0,element:c},f.metadata&&f.extend(!0,k, c.metadata())):k=c);g=d.href||k.href||(q(c)?c:null);h=d.title!==v?d.title:k.title||"";m=(j=d.content||k.content)?"html":d.type||k.type;!m&&k.isDom&&(m=c.data("fancybox-type"),m||(m=(m=c.prop("class").match(/fancybox\.(\w+)/))?m[1]:null));q(g)&&(m||(b.isImage(g)?m="image":b.isSWF(g)?m="swf":"#"===g.charAt(0)?m="inline":q(c)&&(m="html",j=c)),"ajax"===m&&(l=g.split(/\s+/,2),g=l.shift(),l=l.shift()));j||("inline"===m?g?j=f(q(g)?g.replace(/.*(?=#[^\s]+$)/,""):g):k.isDom&&(j=c):"html"===m?j=g:!m&&(!g&& k.isDom)&&(m="inline",j=c));f.extend(k,{href:g,type:m,content:j,title:h,selector:l});a[e]=k}),b.opts=f.extend(!0,{},b.defaults,d),d.keys!==v&&(b.opts.keys=d.keys?f.extend({},b.defaults.keys,d.keys):!1),b.group=a,b._start(b.opts.index)},cancel:function(){var a=b.coming;a&&!1!==b.trigger("onCancel")&&(b.hideLoading(),b.ajaxLoad&&b.ajaxLoad.abort(),b.ajaxLoad=null,b.imgPreload&&(b.imgPreload.onload=b.imgPreload.onerror=null),a.wrap&&a.wrap.stop(!0,!0).trigger("onReset").remove(),b.coming=null,b.current|| b._afterZoomOut(a))},close:function(a){b.cancel();!1!==b.trigger("beforeClose")&&(b.unbindEvents(),b.isActive&&(!b.isOpen||!0===a?(f(".fancybox-wrap").stop(!0).trigger("onReset").remove(),b._afterZoomOut()):(b.isOpen=b.isOpened=!1,b.isClosing=!0,f(".fancybox-item, .fancybox-nav").remove(),b.wrap.stop(!0,!0).removeClass("fancybox-opened"),b.transitions[b.current.closeMethod]())))},play:function(a){var d=function(){clearTimeout(b.player.timer)},e=function(){d();b.current&&b.player.isActive&&(b.player.timer= setTimeout(b.next,b.current.playSpeed))},c=function(){d();p.unbind(".player");b.player.isActive=!1;b.trigger("onPlayEnd")};if(!0===a||!b.player.isActive&&!1!==a){if(b.current&&(b.current.loop||b.current.index<b.group.length-1))b.player.isActive=!0,p.bind({"onCancel.player beforeClose.player":c,"onUpdate.player":e,"beforeLoad.player":d}),e(),b.trigger("onPlayStart")}else c()},next:function(a){var d=b.current;d&&(q(a)||(a=d.direction.next),b.jumpto(d.index+1,a,"next"))},prev:function(a){var d=b.current; d&&(q(a)||(a=d.direction.prev),b.jumpto(d.index-1,a,"prev"))},jumpto:function(a,d,e){var c=b.current;c&&(a=l(a),b.direction=d||c.direction[a>=c.index?"next":"prev"],b.router=e||"jumpto",c.loop&&(0>a&&(a=c.group.length+a%c.group.length),a%=c.group.length),c.group[a]!==v&&(b.cancel(),b._start(a)))},reposition:function(a,d){var e=b.current,c=e?e.wrap:null,k;c&&(k=b._getPosition(d),a&&"scroll"===a.type?(delete k.position,c.stop(!0,!0).animate(k,200)):(c.css(k),e.pos=f.extend({},e.dim,k)))},update:function(a){var d= a&&a.type,e=!d||"orientationchange"===d;e&&(clearTimeout(B),B=null);b.isOpen&&!B&&(B=setTimeout(function(){var c=b.current;c&&!b.isClosing&&(b.wrap.removeClass("fancybox-tmp"),(e||"load"===d||"resize"===d&&c.autoResize)&&b._setDimension(),"scroll"===d&&c.canShrink||b.reposition(a),b.trigger("onUpdate"),B=null)},e&&!s?0:300))},toggle:function(a){b.isOpen&&(b.current.fitToView="boolean"===f.type(a)?a:!b.current.fitToView,s&&(b.wrap.removeAttr("style").addClass("fancybox-tmp"),b.trigger("onUpdate")), b.update())},hideLoading:function(){p.unbind(".loading");f("#fancybox-loading").remove()},showLoading:function(){var a,d;b.hideLoading();a=f('<div id="fancybox-loading"><div></div></div>').click(b.cancel).appendTo("body");p.bind("keydown.loading",function(a){if(27===(a.which||a.keyCode))a.preventDefault(),b.cancel()});b.defaults.fixed||(d=b.getViewport(),a.css({position:"absolute",top:0.5*d.h+d.y,left:0.5*d.w+d.x}))},getViewport:function(){var a=b.current&&b.current.locked||!1,d={x:n.scrollLeft(), y:n.scrollTop()};a?(d.w=a[0].clientWidth,d.h=a[0].clientHeight):(d.w=s&&r.innerWidth?r.innerWidth:n.width(),d.h=s&&r.innerHeight?r.innerHeight:n.height());return d},unbindEvents:function(){b.wrap&&t(b.wrap)&&b.wrap.unbind(".fb");p.unbind(".fb");n.unbind(".fb")},bindEvents:function(){var a=b.current,d;a&&(n.bind("orientationchange.fb"+(s?"":" resize.fb")+(a.autoCenter&&!a.locked?" scroll.fb":""),b.update),(d=a.keys)&&p.bind("keydown.fb",function(e){var c=e.which||e.keyCode,k=e.target||e.srcElement; if(27===c&&b.coming)return!1;!e.ctrlKey&&(!e.altKey&&!e.shiftKey&&!e.metaKey&&(!k||!k.type&&!f(k).is("[contenteditable]")))&&f.each(d,function(d,k){if(1<a.group.length&&k[c]!==v)return b[d](k[c]),e.preventDefault(),!1;if(-1<f.inArray(c,k))return b[d](),e.preventDefault(),!1})}),f.fn.mousewheel&&a.mouseWheel&&b.wrap.bind("mousewheel.fb",function(d,c,k,g){for(var h=f(d.target||null),j=!1;h.length&&!j&&!h.is(".fancybox-skin")&&!h.is(".fancybox-wrap");)j=h[0]&&!(h[0].style.overflow&&"hidden"===h[0].style.overflow)&& (h[0].clientWidth&&h[0].scrollWidth>h[0].clientWidth||h[0].clientHeight&&h[0].scrollHeight>h[0].clientHeight),h=f(h).parent();if(0!==c&&!j&&1<b.group.length&&!a.canShrink){if(0<g||0<k)b.prev(0<g?"down":"left");else if(0>g||0>k)b.next(0>g?"up":"right");d.preventDefault()}}))},trigger:function(a,d){var e,c=d||b.coming||b.current;if(c){f.isFunction(c[a])&&(e=c[a].apply(c,Array.prototype.slice.call(arguments,1)));if(!1===e)return!1;c.helpers&&f.each(c.helpers,function(d,e){if(e&&b.helpers[d]&&f.isFunction(b.helpers[d][a]))b.helpers[d][a](f.extend(!0, {},b.helpers[d].defaults,e),c)});p.trigger(a)}},isImage:function(a){return q(a)&&a.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i)},isSWF:function(a){return q(a)&&a.match(/\.(swf)((\?|#).*)?$/i)},_start:function(a){var d={},e,c;a=l(a);e=b.group[a]||null;if(!e)return!1;d=f.extend(!0,{},b.opts,e);e=d.margin;c=d.padding;"number"===f.type(e)&&(d.margin=[e,e,e,e]);"number"===f.type(c)&&(d.padding=[c,c,c,c]);d.modal&&f.extend(!0,d,{closeBtn:!1,closeClick:!1,nextClick:!1,arrows:!1, mouseWheel:!1,keys:null,helpers:{overlay:{closeClick:!1}}});d.autoSize&&(d.autoWidth=d.autoHeight=!0);"auto"===d.width&&(d.autoWidth=!0);"auto"===d.height&&(d.autoHeight=!0);d.group=b.group;d.index=a;b.coming=d;if(!1===b.trigger("beforeLoad"))b.coming=null;else{c=d.type;e=d.href;if(!c)return b.coming=null,b.current&&b.router&&"jumpto"!==b.router?(b.current.index=a,b[b.router](b.direction)):!1;b.isActive=!0;if("image"===c||"swf"===c)d.autoHeight=d.autoWidth=!1,d.scrolling="visible";"image"===c&&(d.aspectRatio= !0);"iframe"===c&&s&&(d.scrolling="scroll");d.wrap=f(d.tpl.wrap).addClass("fancybox-"+(s?"mobile":"desktop")+" fancybox-type-"+c+" fancybox-tmp "+d.wrapCSS).appendTo(d.parent||"body");f.extend(d,{skin:f(".fancybox-skin",d.wrap),outer:f(".fancybox-outer",d.wrap),inner:f(".fancybox-inner",d.wrap)});f.each(["Top","Right","Bottom","Left"],function(a,b){d.skin.css("padding"+b,w(d.padding[a]))});b.trigger("onReady");if("inline"===c||"html"===c){if(!d.content||!d.content.length)return b._error("content")}else if(!e)return b._error("href"); "image"===c?b._loadImage():"ajax"===c?b._loadAjax():"iframe"===c?b._loadIframe():b._afterLoad()}},_error:function(a){f.extend(b.coming,{type:"html",autoWidth:!0,autoHeight:!0,minWidth:0,minHeight:0,scrolling:"no",hasError:a,content:b.coming.tpl.error});b._afterLoad()},_loadImage:function(){var a=b.imgPreload=new Image;a.onload=function(){this.onload=this.onerror=null;b.coming.width=this.width/b.opts.pixelRatio;b.coming.height=this.height/b.opts.pixelRatio;b._afterLoad()};a.onerror=function(){this.onload= this.onerror=null;b._error("image")};a.src=b.coming.href;!0!==a.complete&&b.showLoading()},_loadAjax:function(){var a=b.coming;b.showLoading();b.ajaxLoad=f.ajax(f.extend({},a.ajax,{url:a.href,error:function(a,e){b.coming&&"abort"!==e?b._error("ajax",a):b.hideLoading()},success:function(d,e){"success"===e&&(a.content=d,b._afterLoad())}}))},_loadIframe:function(){var a=b.coming,d=f(a.tpl.iframe.replace(/\{rnd\}/g,(new Date).getTime())).attr("scrolling",s?"auto":a.iframe.scrolling).attr("src",a.href); f(a.wrap).bind("onReset",function(){try{f(this).find("iframe").hide().attr("src","//about:blank").end().empty()}catch(a){}});a.iframe.preload&&(b.showLoading(),d.one("load",function(){f(this).data("ready",1);s||f(this).bind("load.fb",b.update);f(this).parents(".fancybox-wrap").width("100%").removeClass("fancybox-tmp").show();b._afterLoad()}));a.content=d.appendTo(a.inner);a.iframe.preload||b._afterLoad()},_preloadImages:function(){var a=b.group,d=b.current,e=a.length,c=d.preload?Math.min(d.preload, e-1):0,f,g;for(g=1;g<=c;g+=1)f=a[(d.index+g)%e],"image"===f.type&&f.href&&((new Image).src=f.href)},_afterLoad:function(){var a=b.coming,d=b.current,e,c,k,g,h;b.hideLoading();if(a&&!1!==b.isActive)if(!1===b.trigger("afterLoad",a,d))a.wrap.stop(!0).trigger("onReset").remove(),b.coming=null;else{d&&(b.trigger("beforeChange",d),d.wrap.stop(!0).removeClass("fancybox-opened").find(".fancybox-item, .fancybox-nav").remove());b.unbindEvents();e=a.content;c=a.type;k=a.scrolling;f.extend(b,{wrap:a.wrap,skin:a.skin, outer:a.outer,inner:a.inner,current:a,previous:d});g=a.href;switch(c){case "inline":case "ajax":case "html":a.selector?e=f("<div>").html(e).find(a.selector):t(e)&&(e.data("fancybox-placeholder")||e.data("fancybox-placeholder",f('<div class="fancybox-placeholder"></div>').insertAfter(e).hide()),e=e.show().detach(),a.wrap.bind("onReset",function(){f(this).find(e).length&&e.hide().replaceAll(e.data("fancybox-placeholder")).data("fancybox-placeholder",!1)}));break;case "image":e=a.tpl.image.replace("{href}", g);break;case "swf":e='<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="'+g+'"></param>',h="",f.each(a.swf,function(a,b){e+='<param name="'+a+'" value="'+b+'"></param>';h+=" "+a+'="'+b+'"'}),e+='<embed src="'+g+'" type="application/x-shockwave-flash" width="100%" height="100%"'+h+"></embed></object>"}(!t(e)||!e.parent().is(a.inner))&&a.inner.append(e);b.trigger("beforeShow");a.inner.css("overflow","yes"===k?"scroll": "no"===k?"hidden":k);b._setDimension();b.reposition();b.isOpen=!1;b.coming=null;b.bindEvents();if(b.isOpened){if(d.prevMethod)b.transitions[d.prevMethod]()}else f(".fancybox-wrap").not(a.wrap).stop(!0).trigger("onReset").remove();b.transitions[b.isOpened?a.nextMethod:a.openMethod]();b._preloadImages()}},_setDimension:function(){var a=b.getViewport(),d=0,e=!1,c=!1,e=b.wrap,k=b.skin,g=b.inner,h=b.current,c=h.width,j=h.height,m=h.minWidth,u=h.minHeight,n=h.maxWidth,p=h.maxHeight,s=h.scrolling,q=h.scrollOutside? h.scrollbarWidth:0,x=h.margin,y=l(x[1]+x[3]),r=l(x[0]+x[2]),v,z,t,C,A,F,B,D,H;e.add(k).add(g).width("auto").height("auto").removeClass("fancybox-tmp");x=l(k.outerWidth(!0)-k.width());v=l(k.outerHeight(!0)-k.height());z=y+x;t=r+v;C=E(c)?(a.w-z)*l(c)/100:c;A=E(j)?(a.h-t)*l(j)/100:j;if("iframe"===h.type){if(H=h.content,h.autoHeight&&1===H.data("ready"))try{H[0].contentWindow.document.location&&(g.width(C).height(9999),F=H.contents().find("body"),q&&F.css("overflow-x","hidden"),A=F.outerHeight(!0))}catch(G){}}else if(h.autoWidth|| h.autoHeight)g.addClass("fancybox-tmp"),h.autoWidth||g.width(C),h.autoHeight||g.height(A),h.autoWidth&&(C=g.width()),h.autoHeight&&(A=g.height()),g.removeClass("fancybox-tmp");c=l(C);j=l(A);D=C/A;m=l(E(m)?l(m,"w")-z:m);n=l(E(n)?l(n,"w")-z:n);u=l(E(u)?l(u,"h")-t:u);p=l(E(p)?l(p,"h")-t:p);F=n;B=p;h.fitToView&&(n=Math.min(a.w-z,n),p=Math.min(a.h-t,p));z=a.w-y;r=a.h-r;h.aspectRatio?(c>n&&(c=n,j=l(c/D)),j>p&&(j=p,c=l(j*D)),c<m&&(c=m,j=l(c/D)),j<u&&(j=u,c=l(j*D))):(c=Math.max(m,Math.min(c,n)),h.autoHeight&& "iframe"!==h.type&&(g.width(c),j=g.height()),j=Math.max(u,Math.min(j,p)));if(h.fitToView)if(g.width(c).height(j),e.width(c+x),a=e.width(),y=e.height(),h.aspectRatio)for(;(a>z||y>r)&&(c>m&&j>u)&&!(19<d++);)j=Math.max(u,Math.min(p,j-10)),c=l(j*D),c<m&&(c=m,j=l(c/D)),c>n&&(c=n,j=l(c/D)),g.width(c).height(j),e.width(c+x),a=e.width(),y=e.height();else c=Math.max(m,Math.min(c,c-(a-z))),j=Math.max(u,Math.min(j,j-(y-r)));q&&("auto"===s&&j<A&&c+x+q<z)&&(c+=q);g.width(c).height(j);e.width(c+x);a=e.width(); y=e.height();e=(a>z||y>r)&&c>m&&j>u;c=h.aspectRatio?c<F&&j<B&&c<C&&j<A:(c<F||j<B)&&(c<C||j<A);f.extend(h,{dim:{width:w(a),height:w(y)},origWidth:C,origHeight:A,canShrink:e,canExpand:c,wPadding:x,hPadding:v,wrapSpace:y-k.outerHeight(!0),skinSpace:k.height()-j});!H&&(h.autoHeight&&j>u&&j<p&&!c)&&g.height("auto")},_getPosition:function(a){var d=b.current,e=b.getViewport(),c=d.margin,f=b.wrap.width()+c[1]+c[3],g=b.wrap.height()+c[0]+c[2],c={position:"absolute",top:c[0],left:c[3]};d.autoCenter&&d.fixed&& !a&&g<=e.h&&f<=e.w?c.position="fixed":d.locked||(c.top+=e.y,c.left+=e.x);c.top=w(Math.max(c.top,c.top+(e.h-g)*d.topRatio));c.left=w(Math.max(c.left,c.left+(e.w-f)*d.leftRatio));return c},_afterZoomIn:function(){var a=b.current;a&&(b.isOpen=b.isOpened=!0,b.wrap.css("overflow","visible").addClass("fancybox-opened"),b.update(),(a.closeClick||a.nextClick&&1<b.group.length)&&b.inner.css("cursor","pointer").bind("click.fb",function(d){!f(d.target).is("a")&&!f(d.target).parent().is("a")&&(d.preventDefault(), b[a.closeClick?"close":"next"]())}),a.closeBtn&&f(a.tpl.closeBtn).appendTo(b.skin).bind("click.fb",function(a){a.preventDefault();b.close()}),a.arrows&&1<b.group.length&&((a.loop||0<a.index)&&f(a.tpl.prev).appendTo(b.outer).bind("click.fb",b.prev),(a.loop||a.index<b.group.length-1)&&f(a.tpl.next).appendTo(b.outer).bind("click.fb",b.next)),b.trigger("afterShow"),!a.loop&&a.index===a.group.length-1?b.play(!1):b.opts.autoPlay&&!b.player.isActive&&(b.opts.autoPlay=!1,b.play()))},_afterZoomOut:function(a){a= a||b.current;f(".fancybox-wrap").trigger("onReset").remove();f.extend(b,{group:{},opts:{},router:!1,current:null,isActive:!1,isOpened:!1,isOpen:!1,isClosing:!1,wrap:null,skin:null,outer:null,inner:null});b.trigger("afterClose",a)}});b.transitions={getOrigPosition:function(){var a=b.current,d=a.element,e=a.orig,c={},f=50,g=50,h=a.hPadding,j=a.wPadding,m=b.getViewport();!e&&(a.isDom&&d.is(":visible"))&&(e=d.find("img:first"),e.length||(e=d));t(e)?(c=e.offset(),e.is("img")&&(f=e.outerWidth(),g=e.outerHeight())): (c.top=m.y+(m.h-g)*a.topRatio,c.left=m.x+(m.w-f)*a.leftRatio);if("fixed"===b.wrap.css("position")||a.locked)c.top-=m.y,c.left-=m.x;return c={top:w(c.top-h*a.topRatio),left:w(c.left-j*a.leftRatio),width:w(f+j),height:w(g+h)}},step:function(a,d){var e,c,f=d.prop;c=b.current;var g=c.wrapSpace,h=c.skinSpace;if("width"===f||"height"===f)e=d.end===d.start?1:(a-d.start)/(d.end-d.start),b.isClosing&&(e=1-e),c="width"===f?c.wPadding:c.hPadding,c=a-c,b.skin[f](l("width"===f?c:c-g*e)),b.inner[f](l("width"=== f?c:c-g*e-h*e))},zoomIn:function(){var a=b.current,d=a.pos,e=a.openEffect,c="elastic"===e,k=f.extend({opacity:1},d);delete k.position;c?(d=this.getOrigPosition(),a.openOpacity&&(d.opacity=0.1)):"fade"===e&&(d.opacity=0.1);b.wrap.css(d).animate(k,{duration:"none"===e?0:a.openSpeed,easing:a.openEasing,step:c?this.step:null,complete:b._afterZoomIn})},zoomOut:function(){var a=b.current,d=a.closeEffect,e="elastic"===d,c={opacity:0.1};e&&(c=this.getOrigPosition(),a.closeOpacity&&(c.opacity=0.1));b.wrap.animate(c, {duration:"none"===d?0:a.closeSpeed,easing:a.closeEasing,step:e?this.step:null,complete:b._afterZoomOut})},changeIn:function(){var a=b.current,d=a.nextEffect,e=a.pos,c={opacity:1},f=b.direction,g;e.opacity=0.1;"elastic"===d&&(g="down"===f||"up"===f?"top":"left","down"===f||"right"===f?(e[g]=w(l(e[g])-200),c[g]="+=200px"):(e[g]=w(l(e[g])+200),c[g]="-=200px"));"none"===d?b._afterZoomIn():b.wrap.css(e).animate(c,{duration:a.nextSpeed,easing:a.nextEasing,complete:b._afterZoomIn})},changeOut:function(){var a= b.previous,d=a.prevEffect,e={opacity:0.1},c=b.direction;"elastic"===d&&(e["down"===c||"up"===c?"top":"left"]=("up"===c||"left"===c?"-":"+")+"=200px");a.wrap.animate(e,{duration:"none"===d?0:a.prevSpeed,easing:a.prevEasing,complete:function(){f(this).trigger("onReset").remove()}})}};b.helpers.overlay={defaults:{closeClick:!0,speedOut:200,showEarly:!0,css:{},locked:!s,fixed:!0},overlay:null,fixed:!1,el:f("html"),create:function(a){a=f.extend({},this.defaults,a);this.overlay&&this.close();this.overlay= f('<div class="fancybox-overlay"></div>').appendTo(b.coming?b.coming.parent:a.parent);this.fixed=!1;a.fixed&&b.defaults.fixed&&(this.overlay.addClass("fancybox-overlay-fixed"),this.fixed=!0)},open:function(a){var d=this;a=f.extend({},this.defaults,a);this.overlay?this.overlay.unbind(".overlay").width("auto").height("auto"):this.create(a);this.fixed||(n.bind("resize.overlay",f.proxy(this.update,this)),this.update());a.closeClick&&this.overlay.bind("click.overlay",function(a){if(f(a.target).hasClass("fancybox-overlay"))return b.isActive? b.close():d.close(),!1});this.overlay.css(a.css).show()},close:function(){var a,b;n.unbind("resize.overlay");this.el.hasClass("fancybox-lock")&&(f(".fancybox-margin").removeClass("fancybox-margin"),a=n.scrollTop(),b=n.scrollLeft(),this.el.removeClass("fancybox-lock"),n.scrollTop(a).scrollLeft(b));f(".fancybox-overlay").remove().hide();f.extend(this,{overlay:null,fixed:!1})},update:function(){var a="100%",b;this.overlay.width(a).height("100%");I?(b=Math.max(G.documentElement.offsetWidth,G.body.offsetWidth), p.width()>b&&(a=p.width())):p.width()>n.width()&&(a=p.width());this.overlay.width(a).height(p.height())},onReady:function(a,b){var e=this.overlay;f(".fancybox-overlay").stop(!0,!0);e||this.create(a);a.locked&&(this.fixed&&b.fixed)&&(e||(this.margin=p.height()>n.height()?f("html").css("margin-right").replace("px",""):!1),b.locked=this.overlay.append(b.wrap),b.fixed=!1);!0===a.showEarly&&this.beforeShow.apply(this,arguments)},beforeShow:function(a,b){var e,c;b.locked&&(!1!==this.margin&&(f("*").filter(function(){return"fixed"=== f(this).css("position")&&!f(this).hasClass("fancybox-overlay")&&!f(this).hasClass("fancybox-wrap")}).addClass("fancybox-margin"),this.el.addClass("fancybox-margin")),e=n.scrollTop(),c=n.scrollLeft(),this.el.addClass("fancybox-lock"),n.scrollTop(e).scrollLeft(c));this.open(a)},onUpdate:function(){this.fixed||this.update()},afterClose:function(a){this.overlay&&!b.coming&&this.overlay.fadeOut(a.speedOut,f.proxy(this.close,this))}};b.helpers.title={defaults:{type:"float",position:"bottom"},beforeShow:function(a){var d= b.current,e=d.title,c=a.type;f.isFunction(e)&&(e=e.call(d.element,d));if(q(e)&&""!==f.trim(e)){d=f('<div class="fancybox-title fancybox-title-'+c+'-wrap">'+e+"</div>");switch(c){case "inside":c=b.skin;break;case "outside":c=b.wrap;break;case "over":c=b.inner;break;default:c=b.skin,d.appendTo("body"),I&&d.width(d.width()),d.wrapInner('<span class="child"></span>'),b.current.margin[2]+=Math.abs(l(d.css("margin-bottom")))}d["top"===a.position?"prependTo":"appendTo"](c)}}};f.fn.fancybox=function(a){var d, e=f(this),c=this.selector||"",k=function(g){var h=f(this).blur(),j=d,k,l;!g.ctrlKey&&(!g.altKey&&!g.shiftKey&&!g.metaKey)&&!h.is(".fancybox-wrap")&&(k=a.groupAttr||"data-fancybox-group",l=h.attr(k),l||(k="rel",l=h.get(0)[k]),l&&(""!==l&&"nofollow"!==l)&&(h=c.length?f(c):e,h=h.filter("["+k+'="'+l+'"]'),j=h.index(this)),a.index=j,!1!==b.open(h,a)&&g.preventDefault())};a=a||{};d=a.index||0;!c||!1===a.live?e.unbind("click.fb-start").bind("click.fb-start",k):p.undelegate(c,"click.fb-start").delegate(c+ ":not('.fancybox-item, .fancybox-nav')","click.fb-start",k);this.filter("[data-fancybox-start=1]").trigger("click");return this};p.ready(function(){var a,d;f.scrollbarWidth===v&&(f.scrollbarWidth=function(){var a=f('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo("body"),b=a.children(),b=b.innerWidth()-b.height(99).innerWidth();a.remove();return b});if(f.support.fixedPosition===v){a=f.support;d=f('<div style="position:fixed;top:20px;"></div>').appendTo("body");var e=20=== d[0].offsetTop||15===d[0].offsetTop;d.remove();a.fixedPosition=e}f.extend(b.defaults,{scrollbarWidth:f.scrollbarWidth(),fixed:f.support.fixedPosition,parent:f("body")});a=f(r).width();J.addClass("fancybox-lock-test");d=f(r).width();J.removeClass("fancybox-lock-test");f("<style type='text/css'>.fancybox-margin{margin-right:"+(d-a)+"px;}</style>").appendTo("head")})})(window,document,jQuery);

// jQuery Clipboard :: Fork of zClip :: Uses ZeroClipboard v1.3.2
(function(e){var t=null;var n=false;e.fn.clipboard=function(n){if(typeof n=="object"&&!n.length||typeof n=="undefined"){var r=e.extend({path:"jquery.clipboard.swf",copy:null,beforeCopy:null,afterCopy:null,clickAfter:true},n||{});return this.each(function(){var n=e(this);if(n.is(":visible")&&(typeof r.copy=="string"||e.isFunction(r.copy))){if(e.isFunction(r.copy)){n.bind("Clipboard_copy",r.copy)}if(e.isFunction(r.beforeCopy)){n.bind("Clipboard_beforeCopy",r.beforeCopy)}if(e.isFunction(r.afterCopy)){n.bind("Clipboard_afterCopy",r.afterCopy)}if(t===null){ZeroClipboard.config({moviePath:r.path,trustedDomains:"*",hoverClass:"hover",activeClass:"active"});t=new ZeroClipboard(null);t.on("load",function(t){t.on("mouseover",function(t){e(this).trigger("mouseenter")});t.on("mouseout",function(t){e(this).trigger("mouseleave")});t.on("mousedown",function(t){e(this).trigger("mousedown");if(!e.isFunction(r.copy)){t.setText(r.copy)}else{t.setText(e(this).triggerHandler("Clipboard_copy"))}if(e.isFunction(r.beforeCopy)){e(this).trigger("Clipboard_beforeCopy")}});t.on("complete",function(t,n){if(e.isFunction(r.afterCopy)){e(this).trigger("Clipboard_afterCopy")}else{e(this).removeClass("hover")}if(r.clickAfter){e(this).trigger("click")}})})}t.clip([n[0]])}})}}})(jQuery);(function(){"use strict";function _(e){return e.replace(/,/g,".").replace(/[^0-9\.]/g,"")}function D(e){return parseFloat(_(e))>=10}var e;var t={bridge:null,version:"0.0.0",disabled:null,outdated:null,ready:null};var n={};var r=0;var i={};var s=0;var o={};var u=null;var a=null;var f=function(){var e,t,n,r,i="ZeroClipboard.swf";if(document.currentScript&&(r=document.currentScript.src)){}else{var s=document.getElementsByTagName("script");if("readyState"in s[0]){for(e=s.length;e--;){if(s[e].readyState==="interactive"&&(r=s[e].src)){break}}}else if(document.readyState==="loading"){r=s[s.length-1].src}else{for(e=s.length;e--;){n=s[e].src;if(!n){t=null;break}n=n.split("#")[0].split("?")[0];n=n.slice(0,n.lastIndexOf("/")+1);if(t===null){t=n}else if(t!==n){t=null;break}}if(t!==null){r=t}}}if(r){r=r.split("#")[0].split("?")[0];i=r.slice(0,r.lastIndexOf("/")+1)+i}return i}();var l=function(){var e=/\-([a-z])/g,t=function(e,t){return t.toUpperCase()};return function(n){return n.replace(e,t)}}();var c=function(e,t){var n,r,i,s,o,u;if(window.getComputedStyle){n=window.getComputedStyle(e,null).getPropertyValue(t)}else{r=l(t);if(e.currentStyle){n=e.currentStyle[r]}else{n=e.style[r]}}if(t==="cursor"){if(!n||n==="auto"){i=e.tagName.toLowerCase();if(i==="a"){return"pointer"}}}return n};var h=function(e){if(!e){e=window.event}var t;if(this!==window){t=this}else if(e.target){t=e.target}else if(e.srcElement){t=e.srcElement}P.activate(t)};var p=function(e,t,n){if(!e||e.nodeType!==1){return}if(e.addEventListener){e.addEventListener(t,n,false)}else if(e.attachEvent){e.attachEvent("on"+t,n)}};var d=function(e,t,n){if(!e||e.nodeType!==1){return}if(e.removeEventListener){e.removeEventListener(t,n,false)}else if(e.detachEvent){e.detachEvent("on"+t,n)}};var v=function(e,t){if(!e||e.nodeType!==1){return e}if(e.classList){if(!e.classList.contains(t)){e.classList.add(t)}return e}if(t&&typeof t==="string"){var n=(t||"").split(/\s+/);if(e.nodeType===1){if(!e.className){e.className=t}else{var r=" "+e.className+" ",i=e.className;for(var s=0,o=n.length;s<o;s++){if(r.indexOf(" "+n[s]+" ")<0){i+=" "+n[s]}}e.className=i.replace(/^\s+|\s+$/g,"")}}}return e};var m=function(e,t){if(!e||e.nodeType!==1){return e}if(e.classList){if(e.classList.contains(t)){e.classList.remove(t)}return e}if(t&&typeof t==="string"||t===undefined){var n=(t||"").split(/\s+/);if(e.nodeType===1&&e.className){if(t){var r=(" "+e.className+" ").replace(/[\n\t]/g," ");for(var i=0,s=n.length;i<s;i++){r=r.replace(" "+n[i]+" "," ")}e.className=r.replace(/^\s+|\s+$/g,"")}else{e.className=""}}}return e};var g=function(){var e,t,n,r=1;if(typeof document.body.getBoundingClientRect==="function"){e=document.body.getBoundingClientRect();t=e.right-e.left;n=document.body.offsetWidth;r=Math.round(t/n*100)/100}return r};var y=function(e,t){var n={left:0,top:0,width:0,height:0,zIndex:T(t)-1};if(e.getBoundingClientRect){var r=e.getBoundingClientRect();var i,s,o;if("pageXOffset"in window&&"pageYOffset"in window){i=window.pageXOffset;s=window.pageYOffset}else{o=g();i=Math.round(document.documentElement.scrollLeft/o);s=Math.round(document.documentElement.scrollTop/o)}var u=document.documentElement.clientLeft||0;var a=document.documentElement.clientTop||0;n.left=r.left+i-u;n.top=r.top+s-a;n.width="width"in r?r.width:r.right-r.left;n.height="height"in r?r.height:r.bottom-r.top}return n};var b=function(e,t){var n=t===null||t&&t.cacheBust===true&&t.useNoCache===true;if(n){return(e.indexOf("?")===-1?"?":"&")+"noCache="+(new Date).getTime()}else{return""}};var w=function(e){var t,n,r,i=[],s=[],o=[];if(e.trustedOrigins){if(typeof e.trustedOrigins==="string"){s.push(e.trustedOrigins)}else if(typeof e.trustedOrigins==="object"&&"length"in e.trustedOrigins){s=s.concat(e.trustedOrigins)}}if(e.trustedDomains){if(typeof e.trustedDomains==="string"){s.push(e.trustedDomains)}else if(typeof e.trustedDomains==="object"&&"length"in e.trustedDomains){s=s.concat(e.trustedDomains)}}if(s.length){for(t=0,n=s.length;t<n;t++){if(s.hasOwnProperty(t)&&s[t]&&typeof s[t]==="string"){r=k(s[t]);if(!r){continue}if(r==="*"){o=[r];break}o.push.apply(o,[r,"//"+r,window.location.protocol+"//"+r])}}}if(o.length){i.push("trustedOrigins="+encodeURIComponent(o.join(",")))}if(typeof e.jsModuleId==="string"&&e.jsModuleId){i.push("jsModuleId="+encodeURIComponent(e.jsModuleId))}return i.join("&")};var E=function(e,t,n){if(typeof t.indexOf==="function"){return t.indexOf(e,n)}var r,i=t.length;if(typeof n==="undefined"){n=0}else if(n<0){n=i+n}for(r=n;r<i;r++){if(t.hasOwnProperty(r)&&t[r]===e){return r}}return-1};var S=function(e){if(typeof e==="string")throw new TypeError("ZeroClipboard doesn't accept query strings.");if(!e.length)return[e];return e};var x=function(e,t,n,r){if(r){window.setTimeout(function(){e.apply(t,n)},0)}else{e.apply(t,n)}};var T=function(e){var t,n;if(e){if(typeof e==="number"&&e>0){t=e}else if(typeof e==="string"&&(n=parseInt(e,10))&&!isNaN(n)&&n>0){t=n}}if(!t){if(typeof j.zIndex==="number"&&j.zIndex>0){t=j.zIndex}else if(typeof j.zIndex==="string"&&(n=parseInt(j.zIndex,10))&&!isNaN(n)&&n>0){t=n}}return t||0};var N=function(e,t){if(e&&t!==false&&typeof console!=="undefined"&&console&&(console.warn||console.log)){var n="`"+e+"` is deprecated. See docs for more info:\n"+"    https://github.com/zeroclipboard/zeroclipboard/blob/master/docs/instructions.md#deprecations";if(console.warn){console.warn(n)}else{console.log(n)}}};var C=function(){var e,t,n,r,i,s,o=arguments[0]||{};for(e=1,t=arguments.length;e<t;e++){if((n=arguments[e])!==null){for(r in n){if(n.hasOwnProperty(r)){i=o[r];s=n[r];if(o===s){continue}if(s!==undefined){o[r]=s}}}}}return o};var k=function(e){if(e===null||e===""){return null}e=e.replace(/^\s+|\s+$/g,"");if(e===""){return null}var t=e.indexOf("//");e=t===-1?e:e.slice(t+2);var n=e.indexOf("/");e=n===-1?e:t===-1||n===0?null:e.slice(0,n);if(e&&e.slice(-4).toLowerCase()===".swf"){return null}return e||null};var L=function(){var e=function(e,t){var n,r,i;if(e!==null&&t[0]!=="*"){if(typeof e==="string"){e=[e]}if(typeof e==="object"&&"length"in e){for(n=0,r=e.length;n<r;n++){if(e.hasOwnProperty(n)){i=k(e[n]);if(i){if(i==="*"){t.length=0;t.push("*");break}if(E(i,t)===-1){t.push(i)}}}}}}};var t={always:"always",samedomain:"sameDomain",never:"never"};return function(n,r){var i,s=r.allowScriptAccess;if(typeof s==="string"&&(i=s.toLowerCase())&&/^always|samedomain|never$/.test(i)){return t[i]}var o=k(r.moviePath);if(o===null){o=n}var u=[];e(r.trustedOrigins,u);e(r.trustedDomains,u);var a=u.length;if(a>0){if(a===1&&u[0]==="*"){return"always"}if(E(n,u)!==-1){if(a===1&&n===o){return"sameDomain"}return"always"}}return"never"}}();var A=function(e){if(e===null){return[]}if(Object.keys){return Object.keys(e)}var t=[];for(var n in e){if(e.hasOwnProperty(n)){t.push(n)}}return t};var O=function(e){if(e){for(var t in e){if(e.hasOwnProperty(t)){delete e[t]}}}return e};var M=function(){var e=false;if(typeof t.disabled==="boolean"){e=t.disabled===false}else{if(typeof ActiveXObject==="function"){try{if(new ActiveXObject("ShockwaveFlash.ShockwaveFlash")){e=true}}catch(n){}}if(!e&&navigator.mimeTypes["application/x-shockwave-flash"]){e=true}}return e};var P=function(e,n){if(!(this instanceof P)){return new P(e,n)}this.id=""+r++;i[this.id]={instance:this,elements:[],handlers:{}};if(e){this.clip(e)}if(typeof n!=="undefined"){N("new ZeroClipboard(elements, options)",j.debug);P.config(n)}this.options=P.config();if(typeof t.disabled!=="boolean"){t.disabled=!M()}if(t.disabled===false&&t.outdated!==true){if(t.bridge===null){t.outdated=false;t.ready=false;F()}}};P.prototype.setText=function(e){if(e&&e!==""){n["text/plain"]=e;if(t.ready===true&&t.bridge){t.bridge.setText(e)}else{}}return this};P.prototype.setSize=function(e,n){if(t.ready===true&&t.bridge){t.bridge.setSize(e,n)}else{}return this};var H=function(e){if(t.ready===true&&t.bridge){t.bridge.setHandCursor(e)}else{}};P.prototype.destroy=function(){this.unclip();this.off();delete i[this.id]};var B=function(){var e,t,n,r=[],s=A(i);for(e=0,t=s.length;e<t;e++){n=i[s[e]].instance;if(n&&n instanceof P){r.push(n)}}return r};P.version="1.3.2";var j={swfPath:f,trustedDomains:window.location.host?[window.location.host]:[],cacheBust:true,forceHandCursor:false,zIndex:999999999,debug:true,title:null,autoActivate:true};P.config=function(e){if(typeof e==="object"&&e!==null){C(j,e)}if(typeof e==="string"&&e){if(j.hasOwnProperty(e)){return j[e]}return}var t={};for(var n in j){if(j.hasOwnProperty(n)){if(typeof j[n]==="object"&&j[n]!==null){if("length"in j[n]){t[n]=j[n].slice(0)}else{t[n]=C({},j[n])}}else{t[n]=j[n]}}}return t};P.destroy=function(){P.deactivate();for(var e in i){if(i.hasOwnProperty(e)&&i[e]){var n=i[e].instance;if(n&&typeof n.destroy==="function"){n.destroy()}}}var r=I(t.bridge);if(r&&r.parentNode){r.parentNode.removeChild(r);t.ready=null;t.bridge=null}};P.activate=function(n){if(e){m(e,j.hoverClass);m(e,j.activeClass)}e=n;v(n,j.hoverClass);q();var r=j.title||n.getAttribute("title");if(r){var i=I(t.bridge);if(i){i.setAttribute("title",r)}}var s=j.forceHandCursor===true||c(n,"cursor")==="pointer";H(s)};P.deactivate=function(){var n=I(t.bridge);if(n){n.style.left="0px";n.style.top="-9999px";n.removeAttribute("title")}if(e){m(e,j.hoverClass);m(e,j.activeClass);e=null}};var F=function(){var e,n;var r=document.getElementById("global-zeroclipboard-html-bridge");if(!r){var i=P.config();i.jsModuleId=typeof u==="string"&&u||typeof a==="string"&&a||null;var s=L(window.location.host,j);var o=w(i);var f=j.moviePath+b(j.moviePath,j);var l='      <object classid="clsid:d27cdb6e-ae6d-11cf-96b8-444553540000" id="global-zeroclipboard-flash-bridge" width="100%" height="100%">         <param name="movie" value="'+f+'"/>         <param name="allowScriptAccess" value="'+s+'"/>         <param name="scale" value="exactfit"/>         <param name="loop" value="false"/>         <param name="menu" value="false"/>         <param name="quality" value="best" />         <param name="bgcolor" value="#ffffff"/>         <param name="wmode" value="transparent"/>         <param name="flashvars" value="'+o+'"/>         <embed src="'+f+'"           loop="false" menu="false"           quality="best" bgcolor="#ffffff"           width="100%" height="100%"           name="global-zeroclipboard-flash-bridge"           allowScriptAccess="'+s+'"           allowFullScreen="false"           type="application/x-shockwave-flash"           wmode="transparent"           pluginspage="http://www.macromedia.com/go/getflashplayer"           flashvars="'+o+'"           scale="exactfit">         </embed>       </object>';r=document.createElement("div");r.id="global-zeroclipboard-html-bridge";r.setAttribute("class","global-zeroclipboard-container");r.style.position="absolute";r.style.left="0px";r.style.top="-9999px";r.style.width="15px";r.style.height="15px";r.style.zIndex=""+T(j.zIndex);document.body.appendChild(r);r.innerHTML=l}e=document["global-zeroclipboard-flash-bridge"];if(e&&(n=e.length)){e=e[n-1]}t.bridge=e||r.children[0].lastElementChild};var I=function(e){var t=/^OBJECT|EMBED$/;var n=e&&e.parentNode;while(n&&t.test(n.nodeName)&&n.parentNode){n=n.parentNode}return n||null};var q=function(){if(e){var n=y(e,j.zIndex);var r=I(t.bridge);if(r){r.style.top=n.top+"px";r.style.left=n.left+"px";r.style.width=n.width+"px";r.style.height=n.height+"px";r.style.zIndex=n.zIndex+1}if(t.ready===true&&t.bridge){t.bridge.setSize(n.width,n.height)}}return this};P.prototype.on=function(e,n){var r,s,o,u={},a=i[this.id]&&i[this.id].handlers;if(typeof e==="string"&&e){o=e.toLowerCase().split(/\s+/)}else if(typeof e==="object"&&e&&typeof n==="undefined"){for(r in e){if(e.hasOwnProperty(r)&&typeof r==="string"&&r&&typeof e[r]==="function"){this.on(r,e[r])}}}if(o&&o.length){for(r=0,s=o.length;r<s;r++){e=o[r].replace(/^on/,"");u[e]=true;if(!a[e]){a[e]=[]}a[e].push(n)}if(u.noflash&&t.disabled){z.call(this,"noflash",{})}if(u.wrongflash&&t.outdated){z.call(this,"wrongflash",{flashVersion:t.version})}if(u.load&&t.ready){z.call(this,"load",{flashVersion:t.version})}}return this};P.prototype.off=function(e,t){var n,r,s,o,u,a=i[this.id]&&i[this.id].handlers;if(arguments.length===0){o=A(a)}else if(typeof e==="string"&&e){o=e.split(/\s+/)}else if(typeof e==="object"&&e&&typeof t==="undefined"){for(n in e){if(e.hasOwnProperty(n)&&typeof n==="string"&&n&&typeof e[n]==="function"){this.off(n,e[n])}}}if(o&&o.length){for(n=0,r=o.length;n<r;n++){e=o[n].toLowerCase().replace(/^on/,"");u=a[e];if(u&&u.length){if(t){s=E(t,u);while(s!==-1){u.splice(s,1);s=E(t,u,s)}}else{a[e].length=0}}}}return this};P.prototype.handlers=function(e){var t,n=null,r=i[this.id]&&i[this.id].handlers;if(r){if(typeof e==="string"&&e){return r[e]?r[e].slice(0):null}n={};for(t in r){if(r.hasOwnProperty(t)&&r[t]){n[t]=r[t].slice(0)}}}return n};var R=function(e,t,n,r){var s=i[this.id]&&i[this.id].handlers[e];if(s&&s.length){var o,u,a,f=t||this;for(o=0,u=s.length;o<u;o++){a=s[o];t=f;if(typeof a==="string"&&typeof window[a]==="function"){a=window[a]}if(typeof a==="object"&&a&&typeof a.handleEvent==="function"){t=a;a=a.handleEvent}if(typeof a==="function"){x(a,t,n,r)}}}return this};P.prototype.clip=function(e){e=S(e);for(var t=0;t<e.length;t++){if(e.hasOwnProperty(t)&&e[t]&&e[t].nodeType===1){if(!e[t].zcClippingId){e[t].zcClippingId="zcClippingId_"+s++;o[e[t].zcClippingId]=[this.id];if(j.autoActivate===true){p(e[t],"mouseover",h)}}else if(E(this.id,o[e[t].zcClippingId])===-1){o[e[t].zcClippingId].push(this.id)}var n=i[this.id].elements;if(E(e[t],n)===-1){n.push(e[t])}}}return this};P.prototype.unclip=function(e){var t=i[this.id];if(t){var n=t.elements;var r;if(typeof e==="undefined"){e=n.slice(0)}else{e=S(e)}for(var s=e.length;s--;){if(e.hasOwnProperty(s)&&e[s]&&e[s].nodeType===1){r=0;while((r=E(e[s],n,r))!==-1){n.splice(r,1)}var u=o[e[s].zcClippingId];if(u){r=0;while((r=E(this.id,u,r))!==-1){u.splice(r,1)}if(u.length===0){if(j.autoActivate===true){d(e[s],"mouseover",h)}delete e[s].zcClippingId}}}}}return this};P.prototype.elements=function(){var e=i[this.id];return e&&e.elements?e.elements.slice(0):[]};var U=function(e){var t,n,r,s,u,a=[];if(e&&e.nodeType===1&&(t=e.zcClippingId)&&o.hasOwnProperty(t)){n=o[t];if(n&&n.length){for(r=0,s=n.length;r<s;r++){u=i[n[r]].instance;if(u&&u instanceof P){a.push(u)}}}}return a};j.hoverClass="zeroclipboard-is-hover";j.activeClass="zeroclipboard-is-active";j.trustedOrigins=null;j.allowScriptAccess=null;j.useNoCache=true;j.moviePath="ZeroClipboard.swf";P.detectFlashSupport=function(){N("ZeroClipboard.detectFlashSupport",j.debug);return M()};P.dispatch=function(t,n){if(typeof t==="string"&&t){var r=t.toLowerCase().replace(/^on/,"");if(r){var i=e?U(e):B();for(var s=0,o=i.length;s<o;s++){z.call(i[s],r,n)}}}};P.prototype.setHandCursor=function(e){N("ZeroClipboard.prototype.setHandCursor",j.debug);e=typeof e==="boolean"?e:!!e;H(e);j.forceHandCursor=e;return this};P.prototype.reposition=function(){N("ZeroClipboard.prototype.reposition",j.debug);return q()};P.prototype.receiveEvent=function(e,t){N("ZeroClipboard.prototype.receiveEvent",j.debug);if(typeof e==="string"&&e){var n=e.toLowerCase().replace(/^on/,"");if(n){z.call(this,n,t)}}};P.prototype.setCurrent=function(e){N("ZeroClipboard.prototype.setCurrent",j.debug);P.activate(e);return this};P.prototype.resetBridge=function(){N("ZeroClipboard.prototype.resetBridge",j.debug);P.deactivate();return this};P.prototype.setTitle=function(n){N("ZeroClipboard.prototype.setTitle",j.debug);n=n||j.title||e&&e.getAttribute("title");if(n){var r=I(t.bridge);if(r){r.setAttribute("title",n)}}return this};P.setDefaults=function(e){N("ZeroClipboard.setDefaults",j.debug);P.config(e)};P.prototype.addEventListener=function(e,t){N("ZeroClipboard.prototype.addEventListener",j.debug);return this.on(e,t)};P.prototype.removeEventListener=function(e,t){N("ZeroClipboard.prototype.removeEventListener",j.debug);return this.off(e,t)};P.prototype.ready=function(){N("ZeroClipboard.prototype.ready",j.debug);return t.ready===true};var z=function(r,i){r=r.toLowerCase().replace(/^on/,"");var s=i&&i.flashVersion&&_(i.flashVersion)||null;var o=e;var u=true;switch(r){case"load":if(s){if(!D(s)){z.call(this,"onWrongFlash",{flashVersion:s});return}t.outdated=false;t.ready=true;t.version=s}break;case"wrongflash":if(s&&!D(s)){t.outdated=true;t.ready=false;t.version=s}break;case"mouseover":v(o,j.hoverClass);break;case"mouseout":if(j.autoActivate===true){P.deactivate()}break;case"mousedown":v(o,j.activeClass);break;case"mouseup":m(o,j.activeClass);break;case"datarequested":var a=o.getAttribute("data-clipboard-target"),f=!a?null:document.getElementById(a);if(f){var l=f.value||f.textContent||f.innerText;if(l){this.setText(l)}}else{var c=o.getAttribute("data-clipboard-text");if(c){this.setText(c)}}u=false;break;case"complete":O(n);break}var h=o;var p=[this,i];return R.call(this,r,h,p,u)};if(typeof define==="function"&&define.amd){define(["require","exports","module"],function(e,t,n){u=n&&n.id||null;return P})}else if(typeof module==="object"&&module&&typeof module.exports==="object"&&module.exports){a=module.id||null;module.exports=P}else{window.ZeroClipboard=P}})()

// Responsive Tables
$(document).ready(function(){function n(e){e.wrap("<div class='table-wrapper' />");var t=e.clone();t.find("td:not(:first-child), th:not(:first-child)").css("display","none");t.removeClass("responsive");e.closest(".table-wrapper").append(t);t.wrap("<div class='pinned' />");e.wrap("<div class='scrollable' />");i(e,t)}function r(e){e.closest(".table-wrapper").find(".pinned").remove();e.unwrap();e.unwrap()}function i(e,t){var n=e.find("tr"),r=t.find("tr"),i=[];n.each(function(e){var t=$(this),n=t.find("th, td");n.each(function(){var t=$(this).outerHeight(true);i[e]=i[e]||0;if(t>i[e])i[e]=t})});r.each(function(e){$(this).height(i[e])})}var e=false;var t=function(){if($(window).width()<767&&!e){e=true;$("table.responsive").each(function(e,t){n($(t))});return true}else if(e&&$(window).width()>767){e=false;$("table.responsive").each(function(e,t){r($(t))})}};$(window).load(t);$(window).on("redraw",function(){e=false;t()});$(window).on("resize",t)})


$(document).ready(function () {

	/////////////////////////////
	/////////////////////////////
	// GENERAL
	/////////////////////////////
	/////////////////////////////

	// ADD ADMIN CLASS

	if ($("#admin_bar_iframe").length) {
		$("html").addClass("admin");
	};

	// MARKETING BAR

	if ($('.marketing-bar').length ) {
		if (!$.cookie("no-marketing") || $('body').hasClass('demo-mode') ) {
			$(".marketing-bar").delay(500).slideDown(300, function() {
				$(this).removeClass('inactive');
			});
		};

		$(".close-marketing-bar").click(function() {
			$(".marketing-bar").slideUp(300, function() {
				$(this).addClass('inactive');
			});
			$.cookie("no-marketing", 1, { expires: 10, path: '/' });
		})
	};

	// MARKETING POPUP

	if ($('#marketing-popup').length) {
		if (!$.cookie("no-popup") || $('body').hasClass('demo-mode') ) {
			
			function marketingPopup() {
				$('#marketing-popup').foundation('reveal', 'open');
			}

			var delay = $('#marketing-popup').attr('data-delay');

			if ( !(parseInt(delay) > 500) ) {
				delay = 500;
			};

			window.setTimeout(marketingPopup, delay);
		};

		$('#marketing-popup').on('close.fndtn.reveal', function () {
		  $.cookie("no-popup", 1, { expires: 10, path: '/' });
		});

	};

	// MIN-HEIGHT

	$(".inner-wrap").css("min-height", $(window).height());

	$(window).on('resize', function(){
		$(".inner-wrap").css("min-height", $(window).height());
    });
  
  	/////////////////////////////
	/////////////////////////////
	// Password Page
	/////////////////////////////
	/////////////////////////////
  
  	$('.preview-store').click(function() {
  		$('.access').fadeToggle("slow", "linear");
 	 });

	/////////////////////////////
	/////////////////////////////
	// CART
	/////////////////////////////
	/////////////////////////////

	cartInit();

	// CART INITIALIZE

	function cartInit() {
		if ($(".no-items-in-cart").length < 1) {

			// Mini or Mega context
			if ($(window).width() > 640) {
				$(".mega-cart").addClass("active");
				$(".mini-cart").removeClass("active");
			}
			if ($(".mega-cart").hasClass("active")) {
				var context = $(".mega-cart");
			} else if ($(".mini-cart").hasClass("active")) {
				var context = $(".mini-cart");
			}

			// Set up new handlers for item removal and editing
			context.find(".cart-item-remove").click(cartItemRemove);
			context.find(".quantity").change(cartChange);
		}
	}

	// REMOVE ITEM FROM CART

	function cartItemRemove() {

		// Mini or Mega context
		if ($(window).width() > 640) {
			$(".mega-cart").addClass("active");
			$(".mini-cart").removeClass("active");
		}
		if ($(".mega-cart").hasClass("active")) {
			var context = $(".mega-cart");
		} else if ($(".mini-cart").hasClass("active")) {
			var context = $(".mini-cart");
		}

		// Remove it
		var cartItem = $(this).closest(".cart-item"),
			itemId = cartItem.attr("id");
		cartItem.remove();

		// Update the cart
		$.ajax({
			type: 'POST',
			url: '/cart/change.js',
			data:  'quantity=0&id='+itemId,
			dataType: 'json',
			cache: false,
			success: function() {
				if (context.find('.cart-item').length < 1) {
					cartRefresh();
				} else {
					cartChange();
				}
			}
		})
	}
  

	function cartChange() {

		// Mini or Mega context
		if ($(window).width() > 640) {
			$(".mega-cart").addClass("active");
			$(".mini-cart").removeClass("active");
		}
		if ($(".mega-cart").hasClass("active")) {
			var context = $(".mega-cart");
		} else if ($(".mini-cart").hasClass("active")) {
			var context = $(".mini-cart");
		}

		context.find('.quantity').each(function() {

			// Disable any quantities less than 1
			if ($(this).val() < 1) {
				$(this).val(1);
			};
		})

		// Update line prices and get new subtotal
		var newSubtotal = 0;
		context.find('.cart-item').each(function() {
			var quantity = $(this).find(".quantity").val(),
				price = parseFloat(Math.round($(this).find(".item-edit").attr("id") * 100) / 100).toFixed(2),
				lineTotal = parseFloat(Math.round((quantity * price) * 100) / 100).toFixed(2);

			$(this).find('.cart-item-line-price').text("$"+lineTotal);

			newSubtotal += parseFloat(Math.round(($(this).find('.cart-item-line-price').text().substr(1)) * 100) / 100);
		})

		// Update subtotal
		context.find(".subtotal-price").text("$"+newSubtotal.toFixed(2).toString().replace(/^[0]+/g,""));

		$.ajax({
			type: 'POST',
			url: '/cart/update.js',
			data:  context.serialize(),
			dataType: 'json',
			cache: false
		})

		// Update cart count
		cartCount();
	}

	// CART COUNT

	function cartCount() {
		if ($(".no-items-in-cart").length < 1) {

			// Mini or Mega context
			if ($(window).width() > 640) {
				$(".mega-cart").addClass("active");
				$(".mini-cart").removeClass("active");
			}
			if ($(".mega-cart").hasClass("active")) {
				var context = $(".mega-cart");
			} else if ($(".mini-cart").hasClass("active")) {
				var context = $(".mini-cart");
			}

			// Get cart count
			var cartTotal = 0;
			context.find('.cart-item').each(function() {
				cartTotal += +$(this).find('.quantity').val();
			})

			// Update cart count
			if ($(".cart-count").length) {
				if (cartTotal < 1) {
					$(".cart-count").remove();
				} else {
					$(".cart-count").text(cartTotal);
				}
			} else {
				$(".cart-toggle i").append("<span class='cart-count'>"+cartTotal+"</span>");
			}

		} else {
			$(".cart-count").remove();
		}

	}

	// CART REFRESH

	function cartRefresh() {
		if ($(".no-items-in-cart").length < 1) {

			// Mini or Mega context
			if ($(".mega-cart").hasClass("active")) {
				var context = $(".mega-cart");
			} else if ($(".mini-cart").hasClass("active")) {
				var context = $(".mini-cart");
			}
		}

		// Reload the cart
		var url = $("#site_url").attr('content');
		$("#cart").load("?"+$.now()+" #cart-form", function(){
			if ($(window).width() > 640) {
				$(".mega-cart").addClass("active");
				$(".mini-cart").removeClass("active");
			}
			cartInit();
			cartCount();
		});
	}

	// ADD TO CART

	$(".add-to-cart-form").submit(function(){

		var buyButton = $(this).find('button[type="submit"]');

		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			data: $(this).serialize(),
			dataType: 'json',
			cache: false,
			success: function() {

				buyButton.addClass("buy");
				function removeIt() {
					buyButton.removeClass("buy");
				}
				window.setTimeout(removeIt, 2000);

				cartRefresh();
			}          
	    });

		return false;
	})
    
    

	// SWITCH BETWEEN MINI AND MEGA CART

	var waitForFinalEvent = (function () {
	  var timers = {};
	  return function (callback, ms, uniqueId) {
	    if (!uniqueId) {
	      uniqueId = "Don't call this twice without a uniqueId";
	    }
	    if (timers[uniqueId]) {
	      clearTimeout (timers[uniqueId]);
	    }
	    timers[uniqueId] = setTimeout(callback, ms);
	  };
	})();

	if ($(window).width() < 680) {
		var isMobile = true;
	} else {
		var isMobile = false;
		$(".mega-cart").addClass("active");
      	$(".mini-cart").removeClass("active");
	}

	$(window).resize(function () {
	    waitForFinalEvent(function(){
	      if ($(window).width() < 640 && !isMobile) {
	      	$(".mini-cart").addClass("active");
	      	$(".mega-cart").removeClass("active");
	      	isMobile = true;
	      	cartRefresh();
	      } else if ($(window).width() > 640 && isMobile) {
	      	$(".mega-cart").addClass("active");
	      	$(".mini-cart").removeClass("active");
	      	isMobile = false;
	      	cartRefresh();
	      }
	    }, 500, "cartRefresh");
	});

	/////////////////////////////
	/////////////////////////////
	// NAVIGATION
	/////////////////////////////
	/////////////////////////////

	// MOBILE MENU DROPDOWN

	$(".mobile-nav .open-menu").click(function() {
		$(this).siblings(".sub-menu").toggleClass("active");
		if ($(this).text() == "Open") {
			$(this).text("Done");
		} else {
			$(this).text("Open");
		}
	})

	// DROPDOWN

	if (Modernizr.touch) {
		$(".nav .has-dropdown > a").attr('href', 'javascript:;');

		$(".nav .has-dropdown").click(function() {
			$(".dropdown-arrow").hide();
			$(".sub-menu-container").hide();
			if (!$(this).hasClass('open')) {
				$(this).addClass('open');
				$(this).find(".dropdown-arrow").show();
				$(this).children(".sub-menu-container").show();
			} else {
				$(this).removeClass('open');
			}
			$(".nav .has-dropdown").not($(this)).removeClass('open');
		})
	};

	// CART SCROLL

	$(".right-off-canvas-toggle").click(function(e){
		e.preventDefault();
		$('html,body').delay(400).animate({
		  scrollTop: 0
		}, 1000);
	})

	// MENU SCROLL

	$(".left-off-canvas-toggle").click(function(){
		$('html,body').delay(400).animate({
		  scrollTop: 0
		}, 1000);
	})

	// SEARCH

	$(".search-toggle").click(function(){
		if ($(this).attr('href') == '#search') {
			$("#search-top").toggleClass("active");
			$(".search-toggle i").toggleClass("fa-search").toggleClass("fa-times");
			$('.overlay').hide().removeClass('hide').fadeIn();
			return false;
		};
	})

	$('.overlay').click( function() {	 	
		$(this).fadeOut();	 	
		searchTop.removeClass("active");	 	
		searchToggle.addClass("fa-search");	 	
		searchToggle.removeClass("fa-times");	 	
	});

	$(document).keyup(function(e) {
	  if (e.keyCode == 27) {
	  	$('.overlay').fadeOut();
	  	searchTop.removeClass("active");	 	
	  	searchToggle.addClass("fa-search");	 	
	  	searchToggle.removeClass("fa-times");	
	  }
	});

	// STICKY NAV

	var nav = $(".top-menu"),
		mainSection = $(".main-section"),
		searchTop = $("#search-top"),
		searchToggle = $(".search-toggle i"),
		offsetY = nav.offset().top,
		marketingBar = $('.marketing-bar'),
		done,
		finished;

	$(window).scroll(function(){
		if (!marketingBar.hasClass('inactive') && done != 'done' ) {
			offsetY = nav.offset().top;
			done = 'done';
		} else if (marketingBar.hasClass('inactive') && done == 'done' && finished != 'finished') {
			offsetY = nav.offset().top;
			finished = 'finished';
		}
		if ($(window).scrollTop() > offsetY) {
			nav.addClass("scrolled");
			mainSection.addClass("scrolled");
			searchTop.removeClass("active");
			searchToggle.addClass("fa-search");
			searchToggle.removeClass("fa-times");
			$('.overlay').fadeOut();
		} else {
			nav.removeClass("scrolled");
			mainSection.removeClass("scrolled");
		}
	})

	/////////////////////////////
	/////////////////////////////
	// HOME
	/////////////////////////////
	/////////////////////////////

	// SLIDER

	imagesLoaded($(".home-slider img"), function(){
		setTimeout($(".home-slider").css("opacity", "1"), 500);
	})

	/////////////////////////////
	/////////////////////////////
	// PRODUCT ACCORDION
	/////////////////////////////
	/////////////////////////////

	// ACCORDION FUNCTION

	function accordion(x){
		var $parent = x.closest(".product-thumb"),
			sibling = $parent.next(".product-details"),
			activeDetails = $(".product-details.active"),
			n = 0,
			rowIndex = 0,
			theArray = [[]],
			rowArray = [],
			activeProduct = $(".product-thumb.active");

		// separate products into rows
		$(".product-thumb").each(function(){

			theArray[rowIndex].push(n);
			n++;

			if (n%3==0) {
				theArray.push([]);
				rowIndex++;
			};
		})

		// get current row
		for (var i = 0; i <= theArray.length - 1; i++) {
			if ( $.inArray( $(".product-thumb").index($parent), theArray[i]) >= 0 ) {
				rowArray = theArray[i];
			};
		};

		// if same row, no transition effects
		// else, transition effects
		if ( $.inArray( $(".product-details").index(activeDetails), rowArray) >= 0 && $(window).width() > 640 ) {

			$(".product-details").removeClass("active").hide();

			$parent.css({
				"transition": "none",
				"margin-bottom": sibling.height()+32
			});

			$(".product-thumb").not($parent).removeClass("active").css({
				"transition": "none",
				"margin-bottom": 0
			});
			$parent.addClass("active");

			sibling
				.show()
					.css("top", $parent.height()-1)
						.addClass("active");

			// setTimeout(function(){
			// 	$(".product-thumb").css("transition", "margin-bottom .4s ease");
			// }, 400)

		} else {

			$(".product-details").removeClass("active").hide();

			$(".product-thumb").removeClass("active").css("margin-bottom", 0);
			$parent.addClass("active");

			sibling
				.show()
					.css("top", $parent.height()-1)
						.addClass("active");

			$parent.css("margin-bottom", sibling.height()+32);

			$('html,body').animate({
			  scrollTop: $parent.offset().top
			}, 1000);

		}

		return false;
	}

	// PRODUCT FILTER

	$(".product-filter").change(function() {
		window.location = $(this).find("option:selected").val();
	})

	// PRODUCT LIST

	$(window).on('resize', function(){
		var activeHeight = $(".product-details.active").height();
		$(".product-thumb.active").css("margin-bottom", activeHeight+32);
		$(".product-details.active").css("top", $(".product-thumb.active").height()-1);
    });

    // ASPECT RATIO

    imagesLoaded($(".product-image img"), function(){
    	$(".product-image img").each(function(){
    		var ratio1 = $(".product-image").attr('data-aspect-ratio1'),
    			ratio2 = $(".product-image").attr('data-aspect-ratio2'),
    			ratio = ratio2/ratio1;
    		if (ratio1 && ratio2) {
    			if ($(this).height() > (301*ratio+3) || $(this).height() < (301*ratio-2) ) {
    				$(this).parent("div").addClass("img-fix").css('padding-top', ratio*100+'%');
    			};
    		} else {
    			if ($(this).height() > 165 || $(this).height() < 160 ) {
    				$(this).parent("div").addClass("img-fix").css('padding-top', ratio*100+'%');
    			};
    		}
    	})
    })

    // PRODUCT HOVER IMAGE SWAP

    if ($(window).width() > 900) {
    	$(".product-image").hover(function() {
    		$(this).find('.th').addClass('test');
    		var theImage = $(this).find('.th'),
    			originalSrc = theImage.attr('src'),
    			hoverSrc = theImage.attr('data-hover-src');

    		theImage.attr('src', hoverSrc);
    		theImage.attr('data-hover-src', originalSrc);

    	}, function() {
    		var theImage = $(this).find('.th'),
    			originalSrc = theImage.attr('src'),
    			hoverSrc = theImage.attr('data-hover-src');

    		theImage.attr('src', hoverSrc);
    		theImage.attr('data-hover-src', originalSrc);
    	})
    }

	/////////////////////////////
	/////////////////////////////
	// PRODUCT PULL-OUT
	/////////////////////////////
	/////////////////////////////

	// CLOSE ACCORDION

	$(".close-product-details").click(function() {
		$(this).parents(".product-details")
			.removeClass("active")
				.hide();
		$(".product-thumb").removeClass("active").css("margin-bottom", 0);
	})

	// SOCIAL LINKS

	$(".like").click(function() {
		$(this).siblings(".social-links").addClass("active");
		return false;
	})

	$(".close-social-links").click(function() {
		$(this).parents(".social-links").removeClass("active");
	})

    $(".copy-link").click(function(e) {
    	e.preventDefault();
    	var text = $(this).attr('href');
    	window.prompt("Copy to clipboard: Ctrl/Cmd + C, Enter", text);
    })

    // IMAGE ZOOM

    if (Modernizr.touch == false && $(window).width() > 800) {
    	$('.zoom-container').each(function() {
    		$(this).css('background-image', 'url('+$(this).attr("data-src")+')');
    	})

    	$(".featured-img").click(function(e) {
    		var offset = $(this).offset(),
    			theWidth = $(this).width(),
    			theHeight = $(this).height(),
    	    	relativeXPosition = (e.pageX - offset.left)/theWidth,
    	    	relativeYPosition = (e.pageY - offset.top)/theHeight,
    	    	zoomContainer = $(this).siblings('.zoom-container');

    	    $(this).toggleClass('active');
    	    zoomContainer.toggleClass('active');

    		zoomContainer.css({
    			'background-position-x': relativeXPosition*100+'%',
    			'background-position-y': relativeYPosition*100+'%'
    		})
    	})

    	$(".featured-img").mousemove(function(e) {
    		var offset = $(this).offset(),
    			theWidth = $(this).width(),
    			theHeight = $(this).height(),
    	    	relativeXPosition = (e.pageX - offset.left)/theWidth,
    	    	relativeYPosition = (e.pageY - offset.top)/theHeight,
    	    	zoomContainer = $(this).siblings('.zoom-container');

    	    if (zoomContainer.hasClass('active')) {
    	    	zoomContainer.css({
    	    		'background-position-x': relativeXPosition*100+'%',
    	    		'background-position-y': relativeYPosition*100+'%'
    	    	})
    	    };
    	})


    	$(".featured-img").hover(function() {
    	}, function() {
    		$(this).removeClass('active')
    		$('.zoom-container').removeClass('active');
    	})
    }

    // IMAGE SWITCH

    if ($(window).width() > 800) {
    	$('.product-images a').removeAttr('data-reveal-id').click(function(e) {
    		e.preventDefault();
    		var $scope = $(this).closest(".product-details-inner"),
    			imgSrc = $(this).attr('href'),
    			zoomSrc = $(this).attr('data-zoom-src'),
    			$featuredImg = $scope.find('.featured-img img'),
    			$zoomContainer = $scope.find('.zoom-container');
    		$featuredImg.attr('src', imgSrc);
    		$zoomContainer.css('background-image', 'url('+zoomSrc+')');
    	})
    } else {
    	$('.product-images a').click(function(e) {
    		var modal = $('#'+$(this).attr('data-reveal-id')),
    		src = $(this).attr('href');
    		modal.html('<img src="'+src+'"><a class="close-reveal-modal">&#215;</a>')
    	})
    }

    // VARIANT SWITCH

    // $('.product-images a').click(function() {
    // 	var imgAlt = $(this).attr('data-alt'),
    // 		$scope = $(this).closest(".product-details-inner"),
    // 		productOptions = $scope.find('.variant-selector option');

    // 	productOptions.each(function() {
    // 		alert($(this).attr('value'))
    // 		if (imgAlt == $(this).attr('value')) {
    // 		    $(this).prop('selected', true);
    // 		};
    // 	})

    // })

	// QUANITY SWITCH

	$(".product-details .quantity").change(function() {
		var $scope = $(this).closest(".product-details-inner"),
			variantSelector = $scope.find('.variant-selector'),
			currentVariant = $scope.find('.variant-selector option:selected'),
			currentVariantQ = +(currentVariant.attr('data-quantity')),
			oneVariantQ = +($scope.find('.variant-id').attr('data-quantity')) || 0,
			q = $(this).val();

		if (q < 1) {
			$(this).val(1);
		} else {
			if (variantSelector.is(':visible') && currentVariant.length) {

				if (currentVariantQ >= q) {
					if (currentVariant.attr('data-compare-price') !== undefined) {
						$scope.find('.price').html('$ '+(currentVariant.attr('data-price')/100*q).toFixed(2)+'<del>$'+(currentVariant.attr('data-compare-price')/100*q).toFixed(2)+'</del>');
					} else {
						$scope.find('.price').html('$ '+(currentVariant.attr('data-price')/100*q).toFixed(2));
					}
				} else {
					$(this).val(currentVariantQ);
					alert("We're sorry. There are no more items in stock.")
				}

			} else {
				// if oneVariantQ is 0 that means unlimited
				if (!oneVariantQ || oneVariantQ >= q) {
					var $price = $scope.find('.price');

					if ($price.attr('data-compare-price') !== undefined) {
						$price.html('<del>$ '+($price.attr('data-compare-price')/100*q).toFixed(2)+'</del> $'+($price.attr('data-price')/100*q).toFixed(2));
					} else {
						$price.html('$ '+($price.attr('data-price')/100*q).toFixed(2));
					}
				} else {
					$(this).val(oneVariantQ);
					alert("We're sorry. There are no more items in stock.")
				}
				
			}
		}

	})

	// CUSTOMER REVIEWS

	var lastHeight = 0;

	function checkForChanges()
	{
		var $element = $('.product-details.active .shopify-product-reviews');

	    if ($element.height() != lastHeight) {
	        var activeHeight = $(".product-details.active").height();
	        $(".product-thumb.active").css("margin-bottom", activeHeight+32);
	        $(".product-details.active").css("top", $(".product-thumb.active").height()-1);
	        lastHeight = $element.css('height'); 
	    }
	}

	window.setInterval(checkForChanges, 500);

    //INSTAFEED

    var n = 1

    $(".instafeed-container").each(function(){
    	var $this = $(this),
    		instafeedNewer = $this.children(".instafeed-newer"),
			instafeedOlder = $this.children(".instafeed-older"),
			instafeedOne = $this.children(".instafeed-1"),
			instafeedTwo = $this.children(".instafeed-2");

    	$this.children(".instafeed-1").attr('id', 'instafeed'+n);

    	instafeedNewer.click(function() {
    		instafeedTwo.removeClass("active-page");
    		instafeedOne.addClass("active-page");
    		instafeedOlder.addClass("active");
    		$(this).removeClass("active");
    		return false;
    	})

    	instafeedOlder.click(function() {
    		instafeedOne.removeClass("active-page");
    		instafeedTwo.addClass("active-page");
    		instafeedNewer.addClass("active");
    		$(this).removeClass("active");
    		return false;
    	})

    	n++;
    })

    if ( ($(window).width() > 640 && $('body').hasClass('product')) || ($(window).width() > 640 && $('body').hasClass('no-accordion')) ) {
    	var $this = $(".instafeed-container"),
    		instagramTag = $(".instagram-hashtag").text().substr(1),
    		instafeedNewer = $this.children(".instafeed-newer"),
    		instafeedOlder = $this.children(".instafeed-older"),
    		instafeedOne = $this.children(".instafeed-1"),
    		instafeedTwo = $this.children(".instafeed-2"),
    		theTarget = instafeedOne.attr("id");

    	new Instafeed({
    		get: 'tagged',
    		tagName: instagramTag,
    		target: theTarget,
    		clientId: '33c6f22fc82141f7891b3c972f47c346',
    		template: '<a href="{{link}}"><img src="{{image}}" /></a>',
    		orderBy: 'most-liked',
    		limit: 24,
    		error: function() {
    			$this.children(".instafeed-1").hide();
    		},
    		after: function() {
    			var grams = instafeedOne.children("a");
    			if (grams.length>11) {
    				instafeedOlder.addClass("active");
    				var i = 0;
    				grams.each(function(){
    					i++;
    					if ( i > 12 && i < 25 ) {
    						$(this).clone().appendTo(instafeedTwo);
    						$(this).remove();
    					}
    				})
    			};
    			imagesLoaded($this, function() {
    				var activeHeight = $(".product-details.active").height();
    				$(".product-thumb.active").css("margin-bottom", activeHeight+32);
    				$(".product-details.active").css("top", $(".product-thumb.active").height()-1);
    			})
    		}
    	}).run();
    }

	$(".product-status").click(function() {

		if ($(this).closest(".product-list-item").hasClass('no-accordion') == false) {
			accordion($(this));
		};

		var $this = $(this).closest(".product-list-item").find(".instafeed-container"),
			instagramTag = $this.find(".instagram-hashtag").text().substr(1),
			instafeedNewer = $this.children(".instafeed-newer"),
			instafeedOlder = $this.children(".instafeed-older"),
			instafeedOne = $this.children(".instafeed-1"),
			instafeedTwo = $this.children(".instafeed-2"),
			theTarget = instafeedOne.attr("id");

		if ($(window).width() > 640) {
			new Instafeed({
				get: 'tagged',
				tagName: instagramTag,
				target: theTarget,
				clientId: '33c6f22fc82141f7891b3c972f47c346',
				template: '<a href="{{link}}"><img src="{{image}}" /></a>',
				orderBy: 'most-liked',
				limit: 24,
				error: function() {
					$this.children(".instafeed-1").hide();
				},
				after: function() {
					var grams = instafeedOne.children("a");
					if (grams.length>11) {
						instafeedOlder.addClass("active");
						var i = 0;
						grams.each(function(){
							i++;
							if ( i > 12 && i < 25 ) {
								$(this).clone().appendTo(instafeedTwo);
								$(this).remove();
							}
						})
					};
					imagesLoaded($this, function() {
						var activeHeight = $(".product-details.active").height();
						$(".product-thumb.active").css("margin-bottom", activeHeight+32);
						$(".product-details.active").css("top", $(".product-thumb.active").height()-1);
					})
				}
			}).run();
		}

	});

});







